<template src='./Header.html'>
</template>




<script>
export default {
    name: 'app-header'
}
</script>

<style scoped lang='scss' src='./Header.scss'></style>